import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=729049ac&scoped=true&"
import script from "./EventDetails.vue?vue&type=script&lang=js&"
export * from "./EventDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=729049ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729049ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VChip,VCol,VContainer,VRow})
